import environmentConfigEditComponent from './environment_config.edit.component';

let environmentConfigEditModule = angular.module('environmentConfigEdit', [])

    .component('environmentConfigEdit', environmentConfigEditComponent)

    .name;

export default environmentConfigEditModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/environment_config/edit/index.js